// Packages and components
import React from 'react';

import SHDSelectable from '@ui/Selectable/SHDSelectable';
import CameraStatus from './CameraStatus';
import SHDImage from '@ui/Image/SHDImage';

import { Box } from 'grommet';

// Types and interfaces
import { CaptureLogoUrl, CaptureEquipmentName } from './camera-selection.d';
import type { CameraSelectorProps } from './camera-selection.d';
import SHDText from '@ui/Text/SHDText';

const CameraSelector: React.FC<CameraSelectorProps> = ({
  capture,
  status,
  teamName,
  isSelected = false,
  onClick,
}) => {
  // Handlers
  const handleCaptureIcon = () => {
    switch (capture.equipCamera) {
      case CaptureEquipmentName.GOPRO:
        return CaptureLogoUrl.GOPRO;
      case CaptureEquipmentName.MEVO:
      case CaptureEquipmentName.MEVO_SINGLE:
        return CaptureLogoUrl.MEVO;
      case CaptureEquipmentName.MEVO_MULTI:
        return CaptureLogoUrl.MEVO_MULTI;
      case CaptureEquipmentName.RTMP:
        return CaptureLogoUrl.RTMP;
      case CaptureEquipmentName.SMARTPHONE_LEGACY:
      case CaptureEquipmentName.SMARTPHONE:
        return CaptureLogoUrl.SMARTPHONE_LEGACY;
      case CaptureEquipmentName.SIDELINE_APP:
      default:
        return CaptureLogoUrl.SMARTPHONE;
    }
  };

  return (
    <>
      <SHDSelectable
        align="start"
        id={capture._id}
        isActive={isSelected}
        onSelected={() => {
          onClick && onClick(capture);
        }}
      >
        <Box direction="row" justify="between" align="start">
          <Box margin={{ right: 'small' }}>
            <SHDImage
              alt="Icon of camera selection."
              src={handleCaptureIcon()}
              width={48}
              height={48}
            />
          </Box>

          <Box>
            <SHDText style="subhead-bold" color="black">
              {capture.captureName}
            </SHDText>
            <CameraStatus
              status={status}
              targetTeamName={capture.targetTeamName as string}
              teamName={teamName}
            />
          </Box>
        </Box>
      </SHDSelectable>
    </>
  );
};

export default CameraSelector;
